var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"r-icon r-icon-20",class:_vm.classes,on:{"click":_vm.bubbleClick}},[_c('use',{attrs:{"xlink:href":_vm.iconName,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])}
var staticRenderFns = []

export { render, staticRenderFns }